import ZapierCarouselIcon from "@/images/integrations/carousel/zapier.svg"
import SlackCarouselIcon from "@/images/integrations/carousel/slack.svg"
import GoogleCarouselIcon from "@/images/integrations/carousel/google.svg"
import MicrosoftCarouselIcon from "@/images/integrations/carousel/microsoft.svg"
import QuickbooksCarouselIcon from "@/images/integrations/carousel/quickbooks.svg"
import FreeagentCarouselIcon from "@/images/integrations/carousel/freeagent.svg"
import XeroCarouselIcon from "@/images/integrations/carousel/xero.svg"
import FreshbooksCarouselIcon from "@/images/integrations/carousel/freshbooks.svg"
import TranspondCarouselIcon from "@/images/integrations/carousel/transpond.svg"
import TypeformCarouselIcon from "@/images/integrations/carousel/typeform.svg"
import ShopifyCarouselIcon from "@/images/integrations/carousel/shopify.svg"
import SquarespaceCarouselIcon from "@/images/integrations/carousel/squarespace.svg"
import LinkedInCarouselIcon from "@/images/integrations/carousel/linkedin.svg"
import MagicalCarouselIcon from "@/images/integrations/carousel/magical.svg"

const defaultIntegrationCarouselItems = [
  { icon: ZapierCarouselIcon, label: "Zapier" },
  { icon: SlackCarouselIcon, label: "Slack" },
  { icon: GoogleCarouselIcon, label: "Google" },
  { icon: MicrosoftCarouselIcon, label: "Microsoft" },
  { icon: QuickbooksCarouselIcon, label: "QuickBooks" },
  { icon: FreeagentCarouselIcon, label: "FreeAgent" },
  { icon: XeroCarouselIcon, label: "Xero" },
  { icon: FreshbooksCarouselIcon, label: "FreshBooks" },
  { icon: TranspondCarouselIcon, label: "Transpond" },
  { icon: TypeformCarouselIcon, label: "Typeform" },
  { icon: ShopifyCarouselIcon, label: "Shopify" },
  { icon: SquarespaceCarouselIcon, label: "Squarespace" },
  { icon: LinkedInCarouselIcon, label: "LinkedIn" },
  { icon: MagicalCarouselIcon, label: "Magical" },
]

export default defaultIntegrationCarouselItems
